import { useAuth } from '../contexts/AuthContext';

/**
 * RBAC permission check for UI gating.
 *
 * Mirrors the backend rules (users.rbac / RBACGateMiddleware):
 * - admins and superusers can do everything
 * - a user with no role (or no permissions payload) keeps full member access
 * - otherwise the role's matrix must contain the action for the resource
 *
 * Server-side middleware is the source of truth — this only hides UI.
 */
export function usePermission() {
  const { user } = useAuth();

  const can = (resource: string, action: 'view' | 'create' | 'edit' | 'delete' = 'view'): boolean => {
    if (!user) return false;
    if (user.is_superuser || user.is_organization_admin) return true;
    if (!user.permissions) return true; // legacy payload/no role — full access
    const allowed = user.permissions[resource];
    // Role users see only what their matrix grants; admins/role-less users
    // received the full matrix from whoami, so absence means "not granted".
    return Array.isArray(allowed) && allowed.includes(action);
  };

  return { can };
}
